import { render, staticRenderFns } from "./restriktionen-export-modal.vue?vue&type=template&id=498a8d1b&scoped=true"
import script from "./restriktionen-export-modal.vue?vue&type=script&lang=js"
export * from "./restriktionen-export-modal.vue?vue&type=script&lang=js"
import style0 from "./restriktionen-export-modal.vue?vue&type=style&index=0&id=498a8d1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498a8d1b",
  null
  
)

export default component.exports